/// ROUTER ///
import { useNavigate } from "react-router-dom";
/// MUI ///
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
/// TYPES ///
import { ISelfOrderEvent } from "api/types/event";
/// URLS ///
import { event_url } from "components/navigation/endpoints";
import { shop_url } from "components/navigation/endpoints";

interface Props {
  event: ISelfOrderEvent
}

export default function SelfOrderEventBarItem({ event }: Props) {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(`/${event_url}/${shop_url}/${event?.self_order}`)} sx={{ display: "flex", justifyContent: "flex-start", paddingLeft: 0, paddingRight: 0 }}>
      <Typography variant="body2" sx={{ textTransform: "none" }}>{event?.title}</Typography>
    </Button>
  )
}
